<template>
  <div class="row mx-auto mt-4 mb-4">
    <div class="col-12 font-weight-bold px-0 mb-3">
      {{ $tc(i18nMessage, i18nParams) }}
    </div>

    <div class="col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0">
      <button-cancel v-on:clicked="$emit('canceled')" class="btn-w-100" />
    </div>
    <div class="col-12 col-md-4 col-lg-3 mt-1 px-xs-0">
      <button-delete :i18nMessage="i18nDeleteMessage" v-on:clicked="$emit('confirmed')" v-if="confirmButtonType === 'delete'" class="btn-w-100" />
      <button-save v-on:clicked="$emit('confirmed')" v-if="confirmButtonType === 'save'" class="btn-w-100" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ButtonCancel from '../interaction/ButtonCancel.vue';
import ButtonDelete from '../interaction/ButtonDelete.vue';
import ButtonSave from '../interaction/ButtonSave.vue';

export default defineComponent({
  components: { ButtonCancel, ButtonSave, ButtonDelete },
  name: 'ConfirmationMessage',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.confirmAction'
    },
    i18nParams: {
      type: Array,
      default: () => {
        return []
      }
    },
    i18nDeleteMessage: {
      type: String,
      default: 'common.delete'
    },
    confirmButtonType: {
      type: String,
      default: 'save'
    }
  }
});
</script>
